import { render, staticRenderFns } from "./DialogTextField.vue?vue&type=template&id=2db2ea68&scoped=true&"
import script from "./DialogTextField.vue?vue&type=script&lang=ts&"
export * from "./DialogTextField.vue?vue&type=script&lang=ts&"
import style0 from "./DialogTextField.vue?vue&type=style&index=0&id=2db2ea68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db2ea68",
  null
  
)

export default component.exports